var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 8 13"}},[_c('path',{attrs:{"fill-rule":"nonzero","d":"M.59 11.34l4.58-4.59L.59 2.16 2 .75l6 6-6 6z"}})])}
var staticRenderFns = []

export { render, staticRenderFns }